import React, { Fragment } from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import DocumentacionGeneralComponent from './DocumentacionGeneralComponent'
import DocumentacionDomiciliosComponent from './DocumentacionDomiciliosComponent'
import DocumentacionPrediosComponent from './DocumentacionPrediosComponent'
import DocumentacionViverosComponent from './DocumentacionViverosComponent'
import DocumentacionInstalacionesComponent from './DocumentacionInstalacionesComponent'
import DocumentacionMarcasMezcalComponent from './DocumentacionMarcasMezcalComponent'
import DocumentacionMarcasBebidasMezcalComponent from './DocumentacionMarcasBebidasMezcalComponent'
import OficiosComponent from './OficiosComponent'

function DocumentacionComponent(props) {

    let detalleCliente = props?.detalle

    let indexTabs = ['General', 'Domicilios']

    if (detalleCliente.prediocliente.length > 0) {
        indexTabs.push('Predios')
    }

    if (detalleCliente.viverocliente.length > 0) {
        indexTabs.push('Viveros')
    }

    if (detalleCliente.anexocliente.length > 0) {
        indexTabs.push('Instalaciones')
    }

    if (detalleCliente.marcascliente.length > 0) {
        indexTabs.push('Marcas de mezcal')
    }

    if (detalleCliente.marcasproductoconmezcalcliente.length > 0) {
        indexTabs.push('Marcas de bebidas con mezcal')
    }

    if (detalleCliente.oficioscliente.length > 0) {
        indexTabs.push('Oficios')
    }

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`vertical-tabpanel-${index}`}
                aria-labelledby={`vertical-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `vertical-tab-${index}`,
            'aria-controls': `vertical-tabpanel-${index}`,
        };
    }

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box
            sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: 800, boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)', borderRadius: '8px' }}
        >
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                TabIndicatorProps={{ style: { backgroundColor: '#7D9A47' } }}
                sx={{ borderRight: 1, borderColor: 'divider', width: '20%',
                    "& button": { color: '#7D9A47', fontFamily: 'Montserrat', fontWeight: 'bold', textAlign: 'left'},
                    "& button:hover": { color: '#7D9A47', transform: 'scale(1.1)' },
                    "& button.Mui-selected": { backgroundColor: 'rgba(125, 154, 71, 0.3)', color: '#7D9A47' },
                    "&& .MuiTab-root": { alignItems: 'baseline' },
                }}
            >
                {indexTabs.map((tab, index) => (
                    <Tab label={tab} {...a11yProps(index)} />
                ))}
            </Tabs>
            {indexTabs.includes('General') &&
                <TabPanel value={value} index={indexTabs.indexOf('General')} style={{ width: '80%' }}>
                    <DocumentacionGeneralComponent detalle={detalleCliente} />
                </TabPanel>
            }
            {indexTabs.includes('Domicilios') &&
                <TabPanel value={value} index={indexTabs.indexOf('Domicilios')} style={{ width: '80%' }}>
                    <DocumentacionDomiciliosComponent detalle={detalleCliente} />
                </TabPanel>
            }
            {indexTabs.includes('Predios') &&
                <TabPanel value={value} index={indexTabs.indexOf('Predios')} style={{ width: '80%' }}>
                    <DocumentacionPrediosComponent detalle={detalleCliente} />
                </TabPanel>
            }
            {indexTabs.includes('Viveros') &&
                <TabPanel value={value} index={indexTabs.indexOf('Viveros')} style={{ width: '80%' }}>
                    <DocumentacionViverosComponent detalle={detalleCliente} />
                </TabPanel>
            }
            {indexTabs.includes('Instalaciones') &&
                <TabPanel value={value} index={indexTabs.indexOf('Instalaciones')} style={{ width: '80%' }}>
                    <DocumentacionInstalacionesComponent detalle={detalleCliente} />
                </TabPanel>
            }
            {indexTabs.includes('Marcas de mezcal') &&
                <TabPanel value={value} index={indexTabs.indexOf('Marcas de mezcal')} style={{ width: '80%' }}>
                    <DocumentacionMarcasMezcalComponent detalle={detalleCliente} />
                </TabPanel>
            }
            {indexTabs.includes('Marcas de bebidas con mezcal') &&
                <TabPanel value={value} index={indexTabs.indexOf('Marcas de bebidas con mezcal')} style={{ width: '80%' }}>
                    <DocumentacionMarcasBebidasMezcalComponent detalle={detalleCliente} />
                </TabPanel>
            }
            {indexTabs.includes('Oficios') &&
                <TabPanel value={value} index={indexTabs.indexOf('Oficios')} style={{ width: '80%' }}>
                    <OficiosComponent detalle={detalleCliente} />
                </TabPanel>
            }
        </Box>
    );

}



export default DocumentacionComponent